<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#services"
                    @click="$router.push({ name: 'dashboard' })">الخدمات
                </a> </li>
            <li> <span class="divider"> / </span>
                <router-link :to="{ name: 'electronicservices' }">الخدمات الالكترونية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">استخراج بطاقة الرقم القومى </a> </li>
        </template>
    </Path>

    <section v-if="isInquiry && !isInquiryRes" id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div v-if="!isLastRelease && !isJobType" class="row mb-3">
                        <div class="col-md-12">
                            <label for="" class="form-label">هل تم اصدار آخر بطاقة عن طريق خدمات الانترنت أو مركز
                                الاتصالات؟ </label>
                            <div class="row my-9 justify-content-center">
                                <div class="col-12 col-sm-2 mb-3">
                                    <div class="d-flex justify-content-center">
                                        <button type="button" @click="lastReleaseOnline"
                                            class="popup-btn btn-light">نعم</button>
                                        <button type="button" @click="toggleLastRelease();"
                                            class="popup-btn btn-light">لا</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isLastRelease" class="row mb-3">
                        <div class="col-md-6">
                            <label for="" class="form-label">ادخل تاريخ إصدار اخر بطاقة</label>

                            <div class="input-group mb-3">
                                <input v-model="releaseDate" type="month" min="2014-01"
                                    :max="new Date().toISOString().substring(0, 7)" class="form-control "
                                    id="basic-ur4l" aria-describedby="basic-addon3">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <img src="@/assets/images/IDdate.jpg" alt="IDdate" width="400" height="200">
                        </div>
                        <div class="row my-9 justify-content-center">
                            <div class="col-12 col-sm-2 mb-3 mt-3">
                                <div class="d-flex justify-content-center">
                                    <button type="button" @click="exceed7Years()"
                                        class="popup-btn btn-light">التالى</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isJobType" class="row mb-3">
                        <div class="col-md-6">
                            <label for="" class="form-label">اختر نوع الوظيفة</label>

                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <select v-model="jobType" class="form-select" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.jobType.$touch()">
                                        <option v-for="jobtype in JobLookUps" :key="jobtype.Id" :value="jobtype">
                                            {{ jobtype.Name }}</option>
                                    </select>
                                    <p class="data--required" v-for="error of v$.jobType.$errors" :key="error.$uid">
                                        {{ error.$message }}
                                    </p>

                                </div>
                                
                            </div>

                            <div class="row my-9 justify-content-center">
                                <div class="col-12 col-sm-2 mb-3">
                                    <div class="d-flex justify-content-center">
                                        <button type="button"
                                            @click="submitJobInquiry(); toggleJobType(); toggleInquiryResult();"
                                            class="btn1 btn-light">مراجعة الطلب</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Messages id="content" v-show="isInquiryRes && isError" :errorMsg="errorMsg" />


    <section v-if="!isInquiry" id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="basic-url" class="form-label">الاسم رباعي لصاحب البطاقة</label>
                            <div class="input-group mb-3">
                                <div class="row g-3">
                                    <div class="col-6 col-sm">
                                        <input v-model="form.firstName" type="text" class="form-control" id="basic-url1"
                                            aria-describedby="basic-addon3" @blur="v$.form.firstName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.firstName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <div class="col-6 col-sm">
                                        <input v-model="form.secondName" type="text" class="form-control"
                                            id="basic-url2" aria-describedby="basic-addon3"
                                            @blur="v$.form.secondName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.secondName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <div class="col-6 col-sm">
                                        <input v-model="form.thirdName" type="text" class="form-control" id="basic-url3"
                                            aria-describedby="basic-addon3" @blur="v$.form.thirdName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.thirdName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                    <div class="col-6 col-sm">
                                        <input v-model="form.fourthName" type="text" class="form-control"
                                            id="basic-ur4l" aria-describedby="basic-addon3"
                                            @blur="v$.form.fourthName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.fourthName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="basic-url" class="form-label">الرقم القومى</label>
                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <input v-model="form.nid" type="text" class="form-control" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.nid.$touch()">
                                    <p class="data--required" v-for="error of v$.form.nid.$errors" :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-4">
                            <label for="" class="form-label">اسم الام بالكامل </label>
                            <div class="input-group mb-3">
                                <div class="input-group mb-3">
                                    <div class="col-md-12">
                                        <input v-model="form.motherName" type="text" class="form-control "
                                            id="basic-ur4l" aria-describedby="basic-addon3"
                                            @blur="v$.form.motherName.$touch()">
                                        <p class="data--required" v-for="error of v$.form.motherName.$errors"
                                            :key="error.$uid">
                                            {{ error.$message }}
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="" class="form-label">النوع</label>
                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <select v-model="form.gender" class="form-select" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.gender.$touch()">
                                        <option v-for="gender in gender_lookups" :key="gender.Id" :value="gender.Code">
                                            {{ gender.Name }}</option>
                                    </select>
                                    <p class="data--required" v-for="error of v$.form.gender.$errors" :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>

                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="" class="form-label">سبب الطلب</label>
                            <div class="input-group mb-3">
                                <div class="col-md-12">
                                    <select v-model="form.issueReason" class="form-select" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.issueReason.$touch()">
                                        <option v-for="issue in nidIssues_lookups" :key="issue.Id" :value="issue.Code">
                                            {{ issue.Name }}</option>
                                    </select>
                                    <p class="data--required" v-for="error of v$.form.issueReason.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row mb-3  mt-3">
                        <div class="col-6 col-md-3 mb-3">
                            <label for="" class="form-label">اجمالى سعر البطاقة</label>
                        </div>
                        <div class="col-6 col-md-3 mb-3">
                            <input v-model="serviceprice" type="text" readonly="readonly"
                                class="form-control text-center" aria-label="">
                        </div>
                    </div>

                    <div class="row my-9 justify-content-center">
                        <div class="col-12 col-sm-2 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="sendRequest" type="button"
                                    class="btn btn-nid btn-light mx-3 mt-5 align-self-center">
                                    تسجيل الطلب
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <Review v-if="isReview" @close="toggle_isReview()" :serviceprice="serviceprice" :DocCode="NidCode" DocType=" بطاقة"
        :DocData="ReviewDocData" :isNid="true" :NidDocData="DocData" />
</template>


<script>
import { helpers, requiredIf } from "@vuelidate/validators";
import validations from "@/shared/validations.js";
import useVuelidate from "@vuelidate/core";
import { ref } from 'vue';
import { mapGetters, mapActions } from "vuex";
import Path from '@/components/Path.vue';
import Review from "@/components/Review.vue";
import Messages from '@/components/Messages.vue';
import sharedMethods from "@/shared/sharedMethods";
import sharedData from "@/shared/sharedData";
import { debugLog } from "@/plugins/debug";

export default {
    ...sharedMethods,
    name: 'NidView',
    components: { Path, Messages, Review },
    setup() {
        const isInquiry = ref(false);
        const isLastRelease = ref(false);
        const isJobType = ref(false);
        const isInquiryRes = ref(false);
        const isError = ref(false);
        const isReview = ref(false);

        const toggle_isReview = () => {
            isReview.value = !isReview.value;

        }

        const toggleInquiry = () => {
            isInquiry.value = !isInquiry.value;

        }

        const toggleLastRelease = () => {
            isLastRelease.value = !isLastRelease.value;

        }

        const toggleJobType = () => {
            isJobType.value = !isJobType.value;
        }

        const toggleInquiryResult = () => {
            isInquiryRes.value = !isInquiryRes.value;
        }

        return {isReview,toggle_isReview, isInquiry, isError, toggleInquiry, isLastRelease, toggleLastRelease, isJobType, toggleJobType, isInquiryRes, toggleInquiryResult }
    },

    data() {
        return {
            v$: useVuelidate(),

            releaseDate: new Date().toISOString().substring(0, 7),
            jobType: '',
            nidIssues_lookups: [],
            gender_lookups: [],
            JobLookUps: sharedData.JobLookUps,
            NidCode: sharedData.DocumentsCode.NidCode,
            errorMsg: '',
            serviceprice: '',

            responseMessage: '',
            responseCode: 200,


            form: {
                firstName: '',
                secondName: '',
                thirdName: '',
                fourthName: '',
                nid: '',
                motherName: '',
                issueReason: '',
                gender: '',
            }
        }
    },

    computed: {
        ...mapGetters({ NidDocs: "StateDocs",options: "StateOptions", contactInfo: "StateContact" }),

        // CALCULATE THE DURATION BY MONTHS FROM EXPIRED DATE TILL NOW 
        NID_valid_duration() {
            let Year = this.releaseDate.substring(0, 4);
            let Month = this.releaseDate.substring(5, 7);

            let releaseDte = new Date(Year, Month - 1);

            let allMonths = (new Date().getMonth() - releaseDte.getMonth()) + (12 * (new Date().getFullYear() - releaseDte.getFullYear()));
            return allMonths
        },
        // CALCULATE AGE
        calcAge() {
            let dob = this.get_DoB();
            let diff = Date.now() - dob.getTime();
            let age_dt = new Date(diff);

            return Math.abs(age_dt.getUTCFullYear() - 1970);
        },
        // REVIEW DOCUMENT DATA 
        ReviewDocData() {
            return {
                "nidDoc": Object.values(this.NidDocs),
                ...this.contactInfo
            }
        },
        // DOCUMENT DATA 
        DocData() {
            return {
                "nidDoc": [
                    {
                        "name": {
                            "firstName": this.form.firstName,
                            "otherName": this.form.secondName + ' ' + this.form.thirdName + ' ' + this.form.fourthName
                        },
                        "jobName": this.jobType.Name,
                        "nidIssueReasonCode": this.form.issueReason,
                        "jobTypeNIDCode": "NONE"
                    }
                ],
                ...this.contactInfo
            }
        },
        // ERROR CASES
        errors() {
            return {
                "Picture": "يجب الذهاب إلى المقر لتجديد صورة البطاقة",
                "StudentAge>28": "لم يتم استقبال الطلب، يجب شراء استمارة رقم قومي و الحصول علي خاتم الجهة التعليمية لإثبات المهنة الحالية (طالب ) و التوجه بها  إلي أقرب سجل مدني . مع رابط الي خدمة شراء الاستمارات ",
                "IdExpired": `انتهت صلاحية البطاقة التى تبلغ مدتها ${this.jobType.ValidDuration / 12} سنوات لوظيفة: ${this.jobType.Name} ، برجاء التوجه إلى المقر وتجديد البطاقة`,
                "Exceeded7Years": "لقد مر أكثر من سبع سنوات على إصدار البطاقة‘ يجب التوجه إلى المقر لتجديد البطاقة ودفع الغرامة"
            }
        }
    },
    // validations
    validations() {
        return {
            jobType: { requiredIf: helpers.withMessage("*", requiredIf(this.isJobType)), $autoDirty: true },
            ...validations.NID
        }
    },

    created() {
        setTimeout(() => {
            sharedMethods.get_nidIssueReasons().then(res => { this.nidIssues_lookups = res; });
            sharedMethods.get_servicePrice("nidPrice").then(res => { this.serviceprice = res; });
            sharedMethods.get_genders().then(res => { this.gender_lookups = res; });
        }, 200);
        
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.resetDocs();  // store action for resetting number of documents in store to 0

    },

    methods: {
         ...mapActions(["saveDocs", "resetDocs", "deleteDoc"]),

        // VALIDATE DATA BEFORE SUBMISSION AND START INQUIRY
        sendRequest() {
            debugLog(this.isJobType);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.toggleInquiry();

            } else { this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة'); }
        },
        // FINAL SUBMISSION AFTER INQUIRY
        async submitJobInquiry() {
            this.v$.$validate();
            if (!this.v$.$error) {
                if ((this.NID_valid_duration - (this.jobType.ValidDuration - 1)) > 0) {
                    this.reject_request();
                }
                else {
                    // if job === student (id = 6)
                    if (this.jobType.Id === 6 && this.calcAge > 28) {
                        this.isError = true;
                        this.errorMsg = this.errors["StudentAge>28"];
                    }
                    else {
                        // REQUEST SUCCESS
                        debugLog('Documents Data:',this.DocData);
                        this.saveDocument(); // save form data first in the store                      
                        await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                        if (this.responseCode === 200) {
                            this.isReview = true;
                        } else {
                            this.$alerts.toast.error(this.responseMessage);
                        }
                        
                    }
                }
            } else { this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة'); }
        },
        // GET DATE OF BIRTH
        get_DoB() {
            let Year = this.form.nid.substring(1, 3);
            let Month = this.form.nid.substring(3, 5);
            let Day = this.form.nid.substring(5, 7);

            let cutoff = (new Date()).getFullYear() - 2000;

            Year = (Year > cutoff ? '19' : '20') + Year;

            // new Date(year, monthIndex, day, hours, minutes, seconds, milliseconds)
            return new Date(Year, Month - 1, Day)

        },
        // REJECT NID REQUEST
        reject_request() {

            if (this.isInquiry && !this.isLastRelease && !this.isJobType) {
                this.isError = true;
                this.errorMsg = this.errors.Picture;
            }
            else if (this.isInquiry && !this.isLastRelease && this.isJobType) {
                this.isError = true;
                this.errorMsg = this.errors.IdExpired;
            }
            else if (this.isInquiry && this.isLastRelease && !this.isJobType) {
                this.isError = true;
                this.errorMsg = this.errors.Exceeded7Years;
            }
            // this.$alerts.toast.error("لم يتم استقبال الطلب، برجاء التوجه إلى المقر");  
        },
        // CHECK AGE > 60(DOESNOT NEED TO TAKE A PICTURE) OR NOT FOR PHOTOGRAPHING ISSUES
        lastReleaseOnline() {
            if (this.calcAge >= 60) {
                this.toggleLastRelease();
            }
            else {
                this.reject_request();
                this.toggleInquiryResult();
            }
        },
        // Exceeded 7 years case
        exceed7Years() {
            // if nid exceeded 83 months (7 years ela month) reject request, we don't need to know job type
            if (this.NID_valid_duration > 83) {
                this.reject_request();
                this.toggleInquiryResult();
            } else {
                this.toggleLastRelease();
                this.toggleJobType();
            }
        },
        // assign data to variables and save it to the store
        saveDocument() {
            let docData = {
                "numberOfCopies": 1,
                "name": { "fullName": this.form.firstName + ' ' + this.form.secondName + ' ' + this.form.thirdName + ' ' + this.form.fourthName },
                "nid": { "nationalIdenNumber": this.form.nid },
                "relationCode": "SELF"
            }
            let savedata = {
                "document": docData,
            }


            this.saveDocs(savedata);  // store action for saving Documents

        },
    },
}
</script>

<style scoped>
.popup-btn {
    border-radius: 45px;
    min-width: 100px;
    height: 50px;
    font-family: Tajawal-Medium;
    padding-left: 24px;
    padding-right: 24px;
    font-size: 20px;
    margin: 10px;
}

.btn-nid {
    min-width: 250px !important;
}
</style>
